"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowButtonSet_1 = require("../../../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../../../shared/components/editors/CardRowSelectEditor");
var CardEditorContainer_1 = require("../../../../../../../../shared/components/containers/CardEditorContainer");
var BrandOfferCountryEditor = /** @class */ (function (_super) {
    __extends(BrandOfferCountryEditor, _super);
    function BrandOfferCountryEditor(props) {
        return _super.call(this, props) || this;
    }
    BrandOfferCountryEditor.prototype.componentWillMount = function () {
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    app_country_id: _item.app_country_id,
                    app_country_title: _item.app_country_title
                });
            }
        }
        else {
            this.setState({
                app_country_id: 0,
                app_country_title: ""
            });
        }
        this.doReSetRules();
    };
    BrandOfferCountryEditor.prototype.doReSetRules = function () {
        this.setState({
            app_country_rules: { isError: false },
        });
    };
    BrandOfferCountryEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.app_country_id <= 0) || (this.state.app_country_title.length === 0)) {
            this.setState({ app_country_rules: { isError: true, errorMessage: "Страна не выбрана!" } });
            return false;
        }
        return true;
    };
    BrandOfferCountryEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                app_country_id: this.state.app_country_id
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Страна оффера изменена!");
            });
        }
    };
    BrandOfferCountryEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                app_country_id: this.state.app_country_id,
                brand_aff_offer_id: this.props.rootRecord.key
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Страна оффера добавлена!");
            });
        }
    };
    BrandOfferCountryEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    BrandOfferCountryEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Добавить страну оффера";
        }
        else {
            return "Изменить страну оффера";
        }
    };
    BrandOfferCountryEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 300 },
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Страна:", placeholder: "Выберите страну" }, value: { key: this.state.app_country_id, value: this.state.app_country_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        app_country_id: newVal.key,
                        app_country_title: newVal.value,
                        app_country_rules: { isError: false }
                    });
                }, items: this.props.availCountry, required: true, rules: this.state.app_country_rules }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return BrandOfferCountryEditor;
}(React.Component));
exports.default = BrandOfferCountryEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_brands_offers_list/ui/component/options/country/OfferCountryEditor.tsx
// module id = 2427
// module chunks = 0